import 'css-chunksrc/client/common/skeleton/styles.scss';export default {
  "skeleton": "_skeleton_f7hjd_1",
  "load": "_load_f7hjd_1"
};